import React, { useEffect, useState } from 'react'
import ArchitectureExperienceComponent from '../Components/ArchitectureExperienceComponent';
import AdminHeaderComponent from '../Components/AdminHeaderComponent';
import {  getAllBusinessImpactType } from '../Services/AdminService';
import { architectureExperienceResponse, businessImpactTypeResponse } from '../Types/AdminType';
import BusinessImpactTypeComponent from '../Components/BusinessImpactTypeComponent';

function BusinessImpactTypePage() {
 const [adminData, setAdminData] = useState<businessImpactTypeResponse []>([]);
      const [loading, setLoading] = useState<boolean>(true);
      const [error, setError] = useState<string>("");
      
      useEffect(() => {
        const fetchCandidate = async () => {
          try {
            setLoading(true); // Ensure loading is true when starting
            const response = await getAllBusinessImpactType();
  
            console.log("Recruiters Response:", response);
      
            if (response.success) {
              setAdminData(response.data);
            } else {
              setError(response.message || "Could not retrieve Business Impact Type profile.");
            }
          } catch (err) {
            setError("An unexpected error occurred while loading the profile.");
            console.error(err);
          } finally {
            setLoading(false);
          }
        };
      
        fetchCandidate();
      }, []); // Empty dependency array is fine if using localStorage
  
  
      const handleEdit = () => {
        // Implement the logic to edit the Business Impact Type with the given ID and updated data
        console.log(`Edit Business Impact Type with ID:` );
      }
  
      const handleDelete = (id: string) => {
        // Implement the logic to delete the Business Impact Type with the given ID
        console.log(`Delete Business Impact Type with ID: ${id}`);
      }

  return (
    <div>
      {/* <AdminHeaderComponent /> */}
      <BusinessImpactTypeComponent
       data={adminData} 
          onEditSubmit={handleEdit} 
          onDeleteConfirm={handleDelete} 
          onRegisterSubmit={handleEdit}
          menuName="Business Impact Type"/> 
    </div>
  )
}

export default BusinessImpactTypePage